@import '../../stylesheets/defaults'
@import '../../stylesheets/mixins/common'

$content-padding = 52px

+host-styles(mp-modal)
  // default min width
  display block
  pointer-events auto
  position absolute
  width 400px
  z-index $z-modal

+host-styles(mp-modal, '[modal-type="right-drawer"]')
  .mp-modal
    height 100vh

+host-styles(mp-modal, '[modal-type="right-drawer-under-header"]')
  .mp-modal
    height calc(100vh - 61px)
    top 61px

.mp-modal
  align-items stretch
  display flex
  height 100%
  justify-content stretch
  left 0
  min-width 100%
  position absolute
  top 0
  width inherit
  z-index inherit

  &.is-closed
    display none

  &.is-fullscreen
    height 100vh
    position fixed

  &.is-tour-modal
    pointer-events none
    position fixed

// modal backdrop
.mp-modal-backdrop
  background black
  height 100%
  left 0
  position absolute
  top 0
  width 100%

  &.is-open
    opacity 0.75

  &.is-closed
    opacity 0

// modal body
.mp-modal-wrapper
  display flex
  flex 1
  padding var(--modal-content-vertical-padding, $content-padding) $content-padding
  position relative
  width inherit

  &.is-closed
    opacity 0

  &.is-open
    opacity 1
    overflow auto

  &.is-popup
    overflow visible
    padding 0

  &.is-bottom-drawer
    flex-direction column
    padding 0

  &.is-right-drawer
    justify-content flex-end
    padding 0

  &.is-right-drawer-under-header
    justify-content flex-end
    padding 0

  &.is-tour-modal
    align-items flex-end
    justify-content flex-end
    overflow visible

  &.is-top-aligned
    align-items flex-start

.mp-modal-main
  border-radius $border-radius-panel
  margin auto
  position relative

  &.has-background
    background var(--background-color)
    mp-drop-box-shadow()

  &:not(.is-variable-width)
    width inherit

  .mp-modal-wrapper.is-top-aligned &
    margin 0 auto

  // force overflow padding
  &.is-modal
    &::after,
    &::before
      content ''
      display block
      height $content-padding
      pointer-events none
      position absolute
      width 100%

    &::before
      height 100%
      left 100%
      width $content-padding

    &::after
      top 100%

  &.is-right-drawer
    height 100vh

  &.is-right-drawer-under-header
    height calc(100vh - 61px)

  &.is-bottom-drawer
    height 100vh

  &.is-right-drawer, &.is-right-drawer-under-header, &.is-bottom-drawer
    border-radius 0
    margin 0
    width auto

  &.is-tour-modal
    pointer-events auto
    position fixed

  .mp-modal-close-button
    position absolute
    right 12px
    top 12px
    z-index $z-chrome-overlay

    &.close-button-padded
      right 16px
      top 16px

@keyframes slide-in
  from
    opacity 0
    transform translateY(20%)
  to
    opacity 1
    transform translateY(0%)

@keyframes slide-out
  from
    opacity 1
    transform translateY(0%)
  to
    opacity 0
    transform translateY(-20%)

@keyframes slide-in-right
  from
    opacity 0
    transform translateX(100%)
  to
    opacity 1
    transform translateX(0%)

@keyframes slide-out-right
  from
    opacity 1
    transform translateX(0%)
  to
    opacity 0
    transform translateX(100%)

.mp-modal-sliding
  .mp-modal-backdrop.is-closed
    transition opacity 0.3s ease-in

  .mp-modal-backdrop.is-open
    transition opacity 0.3s ease-out

  .mp-modal-wrapper
    transition opacity 0.2s ease-out

  .is-closed .mp-modal-main
    animation-duration 0.2s
    animation-name slide-out

    &.is-right-drawer, &.is-right-drawer-under-header
      animation-name slide-out-right

  .is-open .mp-modal-main
    animation-duration 0.2s
    animation-name slide-in

    &.is-right-drawer, &.is-right-drawer-under-header
      animation-name slide-in-right

  &.mp-modal.is-closed
    display flex
    pointer-events none
